import {ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {WindowEventsService} from '@services/window-events.service';
import {Direction} from '../../enums/direction.enum';
import {AuthService} from '@services/auth.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-sidebar',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit, OnDestroy {
    @ViewChild('menu') menu: ElementRef;

    public menuItems: SidebarMenuItem[] = [
        {title: 'Склад', link: '/equipment', icon: '@menu/storage'},
        {title: 'Специалисты', link: '/specialist', icon: '@menu/specialists'},
    ];

    private _menuNative: HTMLElement;

    private subs: Subscription[] = [];

    constructor(
        private windowEventsService: WindowEventsService,
        private authService: AuthService,
    ) {}

    ngOnInit() {
        this._menuNative = this.menu.nativeElement;
        this.subs.push(
            this.windowEventsService.scrollDirectionChange$.subscribe((dir: number) => {
                dir === Direction.down ? this.scrollMenuDown() : this.scrollMenuUp();
            })
        );

        const user = this.authService.user$.getValue();

        if (this.authService.hasPermissions([UserNamespace.Permission.accessModuleDocuments])) {
            this.menuItems.push({title: 'Документы', link: '/packages', icon: '@menu/documents'});
        }

        if (this.authService.hasPermissions([UserNamespace.Permission.workingObjectList])) {
            this.menuItems.push({title: 'Объекты', link: '/objects', icon: '@menu/factory', isBeta: true});
        }

        this.menuItems.push({title: 'Аттестовать<br>специалиста', link: 'https://noap.lab365.ru', external: true, icon: '@menu/request'});

        if (this.authService.hasPermissions([
            UserNamespace.Permission.accessModuleOrganization,
            UserNamespace.Permission.laboratoryUpdate,
        ])) {
            this.menuItems.push({title: 'Профиль', link: '/organization', icon: '@menu/profile'});
        }
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }

    private scrollMenuUp() {
        if (this._menuNative.scrollTop > 0) {
            if (this._menuNative.scrollTo) {
                this._menuNative.scrollTo({top: 0, behavior: 'smooth'});
            } else {
                this._menuNative.scrollTop = 0;
            }
        }
    }

    private scrollMenuDown() {
        const scrollHeight = this._menuNative.scrollHeight;
        const height = this._menuNative.clientHeight;
        const difference = scrollHeight - height;

        if (difference > 0) {
            if (this._menuNative.scrollTo) {
                this._menuNative.scrollTo({top: difference, behavior: 'smooth'});
            } else {
                this._menuNative.scrollTop = difference;
            }
        }
    }
}

export interface SidebarMenuItem {
    title: string;
    link: string;
    icon: string;
    external?: boolean; // Ссылка внешняя?
    isBeta?: boolean;
}
